import { connect, ConnectedProps } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { StateType } from '../../../../state/reducers';
import { getSearchCount } from '../../../state/actions';

const mapState = ({ queryParams }: StateType) => ({
  selected: queryParams.type,
});

const mapDispatch = (dispatch: ThunkDispatch<StateType, {}, AnyAction>) => ({
  updateCounts() {
    dispatch(getSearchCount());
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
